export default __webpack_public_path__ + "static/media/video9.f55b39d6.mp4";